import React from 'react';

export const definitionsMessages = {
  value: 'Definitions',
  list: [
    {
      value: (
        <>
          In these Terms and Conditions, the following terms shall have the
          respective meanings specified below unless the context otherwise
          requires:
        </>
      ),
      list: [
        {
          value: (
            <>
              <b>&quot;Advertiser&quot;</b> means a user who places a job
              advertisement or promotes any job related activities via the Site.
            </>
          ),
        },
        {
          value: (
            <>
              <b>&quot;Glints&quot;</b> means Glints Pte Ltd.
            </>
          ),
        },
        {
          value: (
            <>
              <b>&quot;Job Seeker(s)&quot;</b> means users seeking employment.
            </>
          ),
        },
        {
          value: (
            <>
              <b>&quot;Site&quot;</b> means any website, job portal or mobile
              application owned and operated by Glints Pte Ltd and its
              affiliates/subsidiaries or its service providers.
            </>
          ),
        },
        {
          value: (
            <>
              The terms &quot;you&quot;, &quot;user&quot; and &quot;users&quot;
              herein refer to all individuals and/or entities accessing and/or
              using the Site at any time for any reason or purpose.
            </>
          ),
        },
      ],
    },
  ],
};
